var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-ash-100 bg-opacity-50 flex items-center"},[_c('div',{staticClass:"max-w-1500 mx-auto px-5 py-5"},[_c('div',{staticClass:"lg:pl-24 pl-0 lg:pt-4 pt-0"},[_c('ResetPasswordCard')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }